import { Navigate, type RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

// Phase I (I-D): the platform console at /platform (platform admins only), and the tenant's
// Settings ▸ Support access (nested under the admin layout in modules/admin/routes.tsx). The
// server-wide pages (backups, jobs, payroll rates, HMRC RTI) moved here from Settings.
const layout = () => import('./console-layout');
const tenants = () => import('./tenants-page');
const support = () => import('./support-pages');
const rates = () => import('@/modules/payroll-rates/rates-page');

export const routes: RouteObject[] = [
  {
    path: 'platform',
    lazy: page(layout, (m) => m.ConsoleLayout),
    children: [
      { index: true, element: <Navigate to="/platform/tenants" replace /> },
      { path: 'tenants', lazy: page(tenants, (m) => m.TenantsPage) },
      { path: 'tenants/:id', lazy: page(tenants, (m) => m.TenantDetailPage) },
      { path: 'support', lazy: page(support, (m) => m.SupportSessionsPage) },
      { path: 'break-glass', lazy: page(support, (m) => m.BreakGlassPage) },
      { path: 'oidc-clients', lazy: page(() => import('./oidc-clients-page'), (m) => m.OidcClientsPlatformPage) }, // K4
      { path: 'audit', lazy: page(() => import('./audit-page'), (m) => m.PlatformAuditPage) },
      { path: 'admins', lazy: page(() => import('./admins-page'), (m) => m.AdminsPage) },
      { path: 'backups', lazy: page(() => import('@/modules/backups/backups-page'), (m) => m.BackupsPage) },
      { path: 'jobs', lazy: page(() => import('@/modules/platform/jobs-page'), (m) => m.JobsPage) },
      { path: 'certificates', lazy: page(() => import('./certificates-page'), (m) => m.CertificatesPage) }, // Server ▸ Certificates
      { path: 'payroll-rates', lazy: page(rates, (m) => m.PayrollRatesPage) },
      { path: 'payroll-rates/:id', lazy: page(rates, (m) => m.PayrollRateSetPage) },
      { path: 'rti', lazy: page(() => import('./rti-page'), (m) => m.RtiPlatformPage) },
      // Phase I integration: the platform-only screens from I-B (plans) and I-E (status page).
      { path: 'plans', lazy: page(() => import('@/modules/subscription/plans-page'), (m) => m.PlansPage) },
      { path: 'status-page', lazy: page(() => import('@/modules/platform-status/status-admin-page'), (m) => m.StatusAdminPage) },
    ],
  },
];
export const orgRoutes: RouteObject[] = [];

export const settingsRoutes: RouteObject[] = [{ path: 'support-access', lazy: page(() => import('./support-access-page'), (m) => m.SupportAccessPage) }];
